;(function($){

    function Customers() {

        var _          = this;       
        _.API          = $("#app_url").val() + "/api/";

        $.ajaxSetup({
          headers:{
            'Accept' : "application/json",
            'Authorization': "Bearer "+$('meta[name="app-token"]').attr('content'),
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
        });

        $("select#customers_id").on("change", function()
        {
          _.reset();

            if($(this).val() == ""){
                return;
            }

            if ($("select#customers_users_id").length > 0) {
                _.customer_users($(this).val());
            }

            if ($("select#tickets_id").length > 0) {
                _.tikets($(this).val());
            }

            if ($("select#contracts_id").length > 0) {
                _.contracts($(this).val());
            }

            if ($("select#departments_customers_id").length > 0) {
                _.departments_customers($(this).val());
            }
        });

        $("select#filter_customers_id").on("change", function()
        {
            if ($("select#tickets_id").length > 0) {
                _.tikets($(this).val());
            }
        });

        if ($("select#customers_users_id").length > 0) {
            _.customer_users($("select#customers_id").val());
        }

        if ($("select#tickets_id").length > 0) {
            _.tikets($("select#customers_id").val());
        }

        if ($("select#contracts_id").length > 0) {
            _.contracts($("select#customers_id").val());
        }       
    }

    Customers.prototype.customer_users =  function(customers_id) {

        if (customers_id == "") {
            return;
        }

        $.get($("#app_url").val() + "/api/cliente/"+customers_id+"/usuarios", function( data ) {
          
            var html = '<option value="">Selecione</option>';

            $.each(data, function(index, value) {
               var selectedStatus = ($("select#customers_users_id").data('active') == index) ? "selected" : "";
               html += '<option value="'+ index +'" '+ selectedStatus +'>'+ value +'</option>';
            });

            $("select#customers_users_id").attr('disabled', false).html(html);
        });        
    };

    Customers.prototype.tikets = function(customers_id)
    {
        var _ = this;

        if (customers_id == "") {
            return;
        }
        //console.log($("select#customers_id").data('filter-project'));

        var filter_project = ($("select#customers_id").data('filter-project') == true) ? 1 : 2;
       
        $.get(this.API + "cliente/"+customers_id+"/tickets?filter_project="+filter_project, function(data)
        {
            console.log(filter_project);
            var html = '<option value="">Selecione</option>';

            $.each(data, function(index, value) {
               var selectedStatus = ($("select#tickets_id").data('active') == index) ? "selected" : "";
               html += '<option value="'+ index +'" '+ selectedStatus +'>'+ value +'</option>';
            });

            $("select#tickets_id").attr('disabled', false).html(html);
        });       
    };

    Customers.prototype.contracts = function(customers_id)
    {
        var _ = this;

        if (customers_id == "") {
            return;
        }
       
        $.get(this.API + "contratos/"+customers_id, function(data)
        {
            var html = '<option value="">Selecione</option>';

            $.each(data, function(index, value) {
               var selectedStatus = ($("select#contracts_id").data('active') == index) ? "selected" : "";
               html += '<option value="'+ index +'" '+ selectedStatus +'>'+ value +'</option>';
            });

            $("select#contracts_id").attr('disabled', false).html(html);
        });       
    };

    Customers.prototype.departments_customers = function(customers_id)
    {
        var _ = this;

        if (customers_id == "") {
            return;
        }
       
        $.get(this.API + "clientes/departamentos/"+customers_id, function(data)
        {
            var html = '<option value="">Selecione</option>';

            $.each(data, function(index, value) {
               var selectedStatus = ($("select#departments_customers_id").data('active') == index) ? "selected" : "";
               html += '<option value="'+ index +'" '+ selectedStatus +'>'+ value +'</option>';
            });

            $("select#departments_customers_id").attr('disabled', false).html(html);
        });       
    };    

    Customers.prototype.reset = function()
    {
        var _ = this;

        $("select#tickets_id").attr('disabled', true).html('<option value="">Selecione</option>');
    }

   	new Customers();

}(jQuery));